export default "__VITE_ASSET__Fuu2jYnq__"